<div class="check-container fadeIn">
  <ion-icon name="checkmark"></ion-icon>
</div>
